<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list>
         <v-list-item
            v-for="item in items"
            :key="item.title"
            :to="item.path"
            link
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block @click="logout()">
            <v-icon left>mdi-logout</v-icon> Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Digital Candidate Concierge</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <v-container>      
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer app>
      <span>&copy; Digital Candidate Concierge 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
  import AuthWrapper from "../../auth/authWrapper";

  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      items: [
      { title: "Companies", icon: "mdi-city", path: "/app/companies/trial" },
      // { title: "Blocked", icon: "mdi-block-helper", path: "/app/blocked-companies/trial" },
      { title: "Archived", icon: "mdi-delete-variant", path: "/app/archived-companies/trial" },      
      { title: "Dashboard", icon: "mdi-view-dashboard", path: "/app/dashboard" },
      { title: "Settings", icon: "mdi-cog", path: "/app/settings" },
    ],
    }),
    created () {
      this.$vuetify.theme.dark = false
    },
    methods: {
      logout() {
        AuthWrapper.service.logout();
      }
    }
  }
</script>